export default __webpack_public_path__ + "b6f6ed6b164b5441a34df19d9f3a6e44.svg";